import React from 'react';
import styles from './index.module.css';
import cx from 'classnames';
import { MentionableTask } from '../../../clients/sidebar/views/CreateTask/create_task/types';
import {
  localTaskIdRegex,
  mentionReplacedDescription,
  escapeRegexSensitiveCharacters
} from './utils';
import * as translations from './strings';
import { getLangKey } from '../../../clients/sidebar/models/Language';

const strings = translations[getLangKey()];

type Props = {
  id: string;
  task?: MentionableTask;
  setActiveTask?: (id: number) => void;
  description: string;
};

export const TaskMention = ({
  id,
  task,
  setActiveTask,
  description
}: Props) => {
  const display = task ? mentionReplacedDescription(task.display) : '';
  return (
    <a
      href={task?.viewURL}
      className={cx({ [styles.notMention]: !task, [styles.taskMention]: task })}
      title={display || strings.noFoundTask}
      onClick={event => {
        event.preventDefault();
        if (task && setActiveTask) setActiveTask(parseInt(id, 10));
      }}
    >
      {task ? (
        <div className={styles.taskMentionInner}>
          <span
            className={cx(
              styles.localTaskId,
              styles[`priority-${task.severity}`]
            )}
          >
            {task.localTaskId}
          </span>
          <span className={styles.taskMentionDisplay}>{display}</span>
        </div>
      ) : (
        description.match(
          localTaskIdRegex(escapeRegexSensitiveCharacters(id))
        )?.[1] || ''
      )}
    </a>
  );
};
